import React from 'react';
import { FastField, Formik } from 'formik';
import { Card, Button } from '@material-ui/core';
import { useHistory, useRouteMatch } from 'react-router-dom';

import FileUploaderInput from '../../components/FileUploaderInput';
import PsmAuditDigitalList from '../PsmAuditDigitalList';
import { createFileValue } from '../../../utils/pageHelpers';
import { mergeAndSortPsmAudits } from '../../../utils/psmAuditList';
import { useUserPermissions } from '../../../utils/effects/userPermissions';
import { useCompanyInfo } from '../../../utils/effects/useCompanyInfo';
import { canCreatePsmAudit } from '../../../utils/psmAuditPermissions';
import useStyles from './styles';

const UploadPsmAuditForm = ({
  handlePsmSubmit,
  psmAuditList,
  companyId,
  hasPermissions,
  digitalAuditList,
  digitalDeleteList,
  onDeleteDigitalAudit,
  onDeleteUploadedAudit,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const match = useRouteMatch();
  const { type } = useUserPermissions();
  const { companyType, level: companyLevel } = useCompanyInfo(companyId);
  const canCreateDigitalAudit = canCreatePsmAudit(type, companyType, companyLevel);

  const companyPath = match.url.replace(/\/$/, '');

  const handleCreateNewAudit = () => {
    history.push(`${companyPath}/psm-audit/new`);
  };

  const createDigitalAuditButton = canCreateDigitalAudit ? (
    <Button variant="contained" color="primary" onClick={handleCreateNewAudit}>
      Create digital audit
    </Button>
  ) : null;

  const mergedAudits = mergeAndSortPsmAudits(psmAuditList, digitalAuditList);
  const hasAudits = mergedAudits.length > 0;

  return (
    <Card className={classes.cardWrapper}>
      <Formik initialValues={{ psmAudit: createFileValue(psmAuditList) }} onSubmit={handlePsmSubmit} enableReinitialize>
        {({ submitForm }) => (
          <>
            <FastField
              name="psmAudit"
              component={FileUploaderInput}
              label="Upload PSM"
              companyId={companyId}
              hasPermissions={hasPermissions}
              listType="documentList"
              handlePsmSubmit={submitForm}
              cardTitle="PSM Audit Documents"
              completedBy
              completedOn
              extraActions={createDigitalAuditButton}
              hideList
            />

            {hasAudits && (
              <div className={classes.auditTable}>
                <PsmAuditDigitalList
                  audits={digitalAuditList}
                  uploadedAudits={psmAuditList}
                  companyId={companyId}
                  deleteList={digitalDeleteList || []}
                  hasPermissions={hasPermissions}
                  onDelete={onDeleteDigitalAudit}
                  onDeleteUploaded={onDeleteUploadedAudit}
                />
              </div>
            )}
          </>
        )}
      </Formik>
    </Card>
  );
};

export default UploadPsmAuditForm;
